/*
 * DROP · menú de escritorio (borrador, copia del tema). Solo actúa en pantallas >= 990px; en celular queda el menú original del tema.
 *  - Encabezado: botón "☰ Menú" + enlaces directos Hombre / Mujer / Marcas (a la izquierda); cuenta, búsqueda, favoritos y carrito (a la derecha).
 *  - "Menú" abre un cajón lateral delgado de una sola columna; las categorías con flecha abren un segundo nivel al lado.
 * Textos y enlaces: variables LINKS, L1, EXPLORA y SUB.
 * v2: LINKS ya trae "Marcas" desde el inicio (antes salía "Más Vendidos" y otro script lo cambiaba a los 0,6 s, lo que se veía como parpadeo al cargar cada página).
 * v3: el encabezado (Menú · Hombre · Mujer · Marcas) ahora lo arma un script en línea de layout/theme.liquid, justo después del encabezado, para que no aparezca tarde. Este archivo solo le conecta el clic del botón "Menú" para abrir el cajón (si no, el clic abría el cajón viejo del tema).
 */
(function () {
  if (window.__dropMenuDesk) return;
  window.__dropMenuDesk = true;
  var mq = window.matchMedia('(min-width:990px)');
  var P = '/collections/';

  var LINKS = [['Hombre', P + 'hombre'], ['Mujer', P + 'ropa-mujer'], ['Marcas', P + 'marcas']];

  /* nivel 1: [texto, enlace] o [texto, null, clave del submenú] */
  var L1 = [
    ['Colecciones', P], ['Más Vendidos', P + 'lo-mas-vendido'], ['Novedades', P + 'recientes'], ['Rebajas', P + 'rebajas'],
    ['Marcas', null, 'marcas'], ['Tenis y Zapatos', null, 'calzado'], ['Mujer', null, 'mujer'], ['Hombre', null, 'hombre'],
    ['Accesorios', null, 'accesorios'], ['Belleza', null, 'belleza'], ['Journal', '/blogs/journal']
  ];
  var EXPLORA = [['Quiénes Somos', '/pages/quienes-somos'], ['Tiendas', '/pages/tiendas'], ['Contacto', '/pages/contacto'], ['Ayuda', '/pages/preguntas-frecuentes']];

  var SUB = {
    hombre: [
      { g: 'Destacados', i: [['Ver Todo', P + 'hombre'], ['Novedades', P + 'novedades-hombre'], ['Más Vendidos', P + 'mas-vendidos-hombre'], ['Rebajas', P + 'rebajas-hombre']] },
      { g: 'Ropa', i: [['Camisetas', P + 'camisetas-hombre'], ['Camisas', P + 'camisas-hombre'], ['Buzos y Hoodies', P + 'hoodies-hombre'], ['Chaquetas', P + 'chaquetas-hombre'], ['Suéteres', P + 'tejidos-hombre'], ['Jeans', P + 'jeans-hombre'], ['Pantalones', P + 'pantalones-hombre'], ['Pantalonetas', P + 'pantalonetas-hombre'], ['Ropa Interior', P + 'ropa-interior-hombre']] },
      { g: 'Tenis y Zapatos', i: [['Ver Todo', P + 'calzado-hombre']] },
      { g: 'Accesorios', i: [['Ver Todo', P + 'accesorios-hombre'], ['Gorras', P + 'gorras-hombre']] }
    ],
    mujer: [
      { g: 'Destacados', i: [['Ver Todo', P + 'ropa-mujer'], ['Novedades', P + 'novedades-mujer'], ['Más Vendidos', P + 'mas-vendidos-mujer'], ['Rebajas', P + 'rebajas-mujer']] },
      { g: 'Ropa', i: [['Camisetas', P + 'camisetas-mujer'], ['Blusas y Camisas', P + 'camisas-mujer'], ['Tops', P + 'tops-mujer'], ['Buzos y Hoodies', P + 'hoodies-mujer'], ['Chaquetas', P + 'chaquetas-mujer'], ['Suéteres', P + 'tejidos-mujer'], ['Jeans', P + 'jeans-mujer'], ['Pantalones', P + 'pantalones-mujer'], ['Shorts', P + 'shorts-mujer'], ['Faldas', P + 'faldas-mujer'], ['Ropa Interior', P + 'underwear-mujer']] },
      { g: 'Tenis y Zapatos', i: [['Ver Todo', P + 'calzado-mujer']] },
      { g: 'Accesorios', i: [['Ver Todo', P + 'accesorios-mujer']] }
    ],
    calzado: [
      { g: 'Destacados', i: [['Ver Todo', P + 'calzado'], ['Novedades', P + 'novedades-calzado'], ['Más Vendidos', P + 'mas-vendidos-calzado'], ['Rebajas', P + 'rebajas-calzado']] },
      { g: 'Tenis y Zapatos', i: [['Tenis y Sneakers', P + 'calzado-lifestyle'], ['Tenis Running', P + 'calzado-deportivo'], ['Botas', P + 'botas'], ['Zapatos', P + 'zapatos'], ['Mocasines', P + 'calzado-formal']] },
      { g: 'Para', i: [['Hombre', P + 'calzado-hombre'], ['Mujer', P + 'calzado-mujer']] }
    ],
    accesorios: [
      { g: 'Accesorios', i: [['Hombre', P + 'accesorios-hombre'], ['Mujer', P + 'accesorios-mujer'], ['Gorras', P + 'gorras-hombre']] }
    ],
    belleza: [
      { g: 'Destacados', i: [['Ver Todo', P + 'belleza'], ['Novedades', P + 'novedades-belleza'], ['Más Vendidos', P + 'mas-vendidos-belleza'], ['Rebajas', P + 'rebajas-belleza']] }
    ],
    marcas: [
      { g: 'Más Vendidas', i: [['Undergold', P + 'undergold'], ['TRUE', P + 'true'], ['UGG', P + 'ugg'], ['Palms Capra', P + 'palms-capra']] },
      { g: 'Recién Llegadas', i: [['Remanence', P + 'remanence'], ['The Frenchie Co', P + 'the-frenchie-co']] },
      { g: 'Todas A–Z', i: [['Astronomic', P + 'astronomic'], ['Classic & Rebels', P + 'classic-rebels'], ['Coolway', P + 'coolway'], ['HOFF', P + 'hoff'], ['Jormands', P + 'jormands'], ['Kith', P + 'kith'], ['Monoic Studios', P + 'monoic-studios'], ['New Era', P + 'new-era'], ['Nude Project', P + 'nude-project'], ['Old Maquiina', P + 'old-maquiina'], ['On Cloud', P + 'on'], ['Palms Capra', P + 'palms-capra'], ['Reeva', P + 'reeva'], ['Rhode', P + 'rhode'], ['Stance', P + 'stance'], ['The Frenchie Co', P + 'the-frenchie-co'], ['TRUE', P + 'true'], ['UGG', P + 'ugg'], ['Undergold', P + 'undergold'], ['Veja', P + 'veja']] }
    ]
  };

  var CH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var XI = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var BI = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M3 7h18M3 12h18M3 17h18"/></svg>';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  var root, n1, n2, openKey = null;

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'dmd';
    root.setAttribute('aria-hidden', 'true');
    var i = 0;
    var l1 = L1.map(function (m) {
      var st = ' style="--i:' + (i++) + '"';
      if (m[2]) return '<li' + st + '><button type="button" class="dmd-i" data-k="' + m[2] + '"><span>' + esc(m[0]) + '</span>' + CH + '</button></li>';
      return '<li' + st + '><a class="dmd-i" href="' + esc(m[1]) + '"><span>' + esc(m[0]) + '</span></a></li>';
    }).join('');
    var ex = EXPLORA.map(function (m) { return '<li style="--i:' + (i++) + '"><a class="dmd-i" href="' + esc(m[1]) + '"><span>' + esc(m[0]) + '</span></a></li>'; }).join('');
    root.innerHTML =
      '<div class="dmd-bg" data-x></div><div class="dmd-wrap">' +
      '<nav class="dmd-n1" aria-label="Menú principal"><div class="dmd-hd"><span class="dmd-logo">DROP</span><button type="button" class="dmd-x" data-x aria-label="Cerrar menú">' + XI + '</button></div>' +
      '<ul class="dmd-ul">' + l1 + '</ul><p class="dmd-lbl">Explora</p><ul class="dmd-ul">' + ex + '</ul>' +
      '<div class="dmd-ft"><a class="dmd-acc" href="/account">Mi Cuenta</a></div></nav>' +
      '<nav class="dmd-n2" aria-label="Submenú" hidden></nav></div>';
    document.body.appendChild(root);
    n1 = root.querySelector('.dmd-n1');
    n2 = root.querySelector('.dmd-n2');
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-x]')) { close(); return; }
      var b = t.closest('button[data-k]');
      if (b) { showSub(b.getAttribute('data-k'), b); return; }
      if (t.closest('.dmd-back')) { hideSub(); return; }
      if (t.closest('a[href]')) close();
    });
  }

  function showSub(k, btn) {
    var g = SUB[k]; if (!g) return;
    if (openKey === k && !n2.hidden) { hideSub(); return; }
    var title = '';
    L1.forEach(function (m) { if (m[2] === k) title = m[0]; });
    var n = 0;
    var h = '<div class="dmd-hd"><button type="button" class="dmd-back">‹ ' + esc(title) + '</button></div><div class="dmd-body">';
    g.forEach(function (gr) {
      h += '<p class="dmd-g" style="--i:' + (n++) + '">' + esc(gr.g) + '</p><ul class="dmd-ul">';
      gr.i.forEach(function (it) { h += '<li style="--i:' + (n++) + '"><a class="dmd-i dmd-i2" href="' + esc(it[1]) + '"><span>' + esc(it[0]) + '</span></a></li>'; });
      h += '</ul>';
    });
    n2.innerHTML = h + '</div>';
    n2.hidden = false; n2.classList.remove('is-in'); void n2.offsetWidth; n2.classList.add('is-in');
    n1.querySelectorAll('.dmd-i.on').forEach(function (x) { x.classList.remove('on'); });
    if (btn) btn.classList.add('on');
    openKey = k;
  }

  function hideSub() {
    if (!n2) return;
    n2.hidden = true; n2.classList.remove('is-in');
    n1.querySelectorAll('.dmd-i.on').forEach(function (x) { x.classList.remove('on'); });
    openKey = null;
  }

  function open() {
    if (!mq.matches) return;
    build(); hideSub();
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dmd-lock');
    setTimeout(function () { var x = root.querySelector('.dmd-x'); if (x) x.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dmd-lock');
    setTimeout(hideSub, 380);
  }

  function wire() {
    var inner = document.querySelector('.header__inner');
    document.documentElement.classList.add('dmd-on');
    if (!inner) return;
    var ex = inner.querySelector('.dmd-left');
    if (ex) {
      /* el encabezado ya lo armó el script en línea de theme.liquid: solo falta conectar el botón "Menú" al cajón */
      var eb = ex.querySelector('.dmd-burger');
      if (eb && !eb.__dmdWired) { eb.__dmdWired = true; eb.addEventListener('click', open); }
      return;
    }
    var left = document.createElement('div');
    left.className = 'dmd-left';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dmd-burger'; b.setAttribute('aria-label', 'Abrir menú');
    b.innerHTML = BI + '<span>Menú</span>';
    b.__dmdWired = true;
    b.addEventListener('click', open);
    left.appendChild(b);
    LINKS.forEach(function (l) {
      var a = document.createElement('a');
      a.className = 'dmd-lnk'; a.href = l[1]; a.textContent = l[0];
      left.appendChild(a);
    });
    var nav = inner.querySelector('nav.header__nav');
    inner.insertBefore(left, nav || inner.firstChild);
  }

  function col() {
    var i = document.querySelector('nav.header__utils a, nav.header__utils button');
    if (i) document.documentElement.style.setProperty('--dmd-c', getComputedStyle(i).color);
  }
  var tk; function tick() { if (tk) return; tk = setTimeout(function () { tk = 0; col(); }, 60); }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', function () { tick(); if (!mq.matches) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function init() { wire(); col(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  setInterval(init, 1000);
})();
